import { bl_inv_reset_moving_average_cost_line_RowClass } from '../../../dbschema/bl_inv_reset_moving_average_cost_line.model';
import { BaseContainerModel } from '../../base-container.model';


export class InvResetMovingAverageCostLineModel extends BaseContainerModel {
  bl_inv_reset_moving_average_cost_line: bl_inv_reset_moving_average_cost_line_RowClass = new bl_inv_reset_moving_average_cost_line_RowClass();
}
